import { WarningOutlined } from '@ant-design/icons';
import { Alert } from 'antd';

function TaxAlert() {
  return (
    <Alert
      type='warning'
      showIcon
      icon={<WarningOutlined />}
      message='A cobrança do IOF ou outros encargos referentes a operadora de cartão de crédito do cliente final são de responsabilidade única e exclusivas dos mesmos. Não há opção de parcelamento para compras internacionais. A conversão em real exibida na tabela acima é apenas um demonstrativo diário do valor cadastrado convertido em real, lembrando que em todas suas vendas o valor do produto será o valor correspondido no momento da compra.'
    />
  );
}

export { TaxAlert };
